export const filtersTypeById = {
  alert_status: {
    id: "alert_status",
    label: "Status",
    allBtnText: "All statuses",
    type: "checkbox"
  },
  alert_type: {
    id: "alert_type",
    label: "Type",
    allBtnText: "All types",
    type: "checkbox"
  },
  alert_reason: {
    id: "alert_reason",
    label: "Alert reason",
    allBtnText: "All reasons",
    type: "checkbox",
    withSearch: true
  },
  steps_finished: {
    id: "steps_finished",
    label: "Steps finished",
    allBtnText: "All Steps",
    type: "checkbox"
  },
  user_full_name: {
    id: "user_full_name",
    label: "User full name",
    title: "User full name",
    searchPlaceholder: "Separate full name by comma",
    type: "tags"
  },
  full_name: {
    id: "full_name",
    label: "User full name",
    title: "User full name",
    searchPlaceholder: "Separate full name by comma",
    type: "tags"
  },
  admin_name: {
    id: "admin_name",
    label: "Admin name",
    title: "Admin name",
    searchPlaceholder: "Separate admin name by comma",
    type: "tags"
  },
  user_email: {
    id: "user_email",
    label: "User email",
    title: "User email",
    searchPlaceholder: "Separate email by comma",
    type: "tags",
    withHide: true
  },
  customer_email: {
    id: "customer_email",
    label: "Customer email",
    title: "Customer email",
    searchPlaceholder: "Separate email by comma",
    type: "tags"
  },
  customer_full_name: {
    id: "customer_full_name",
    label: "Customer full name",
    title: "Customer full name",
    searchPlaceholder: "Separate full name by comma",
    type: "tags"
  },
  email: {
    id: "email",
    label: "User email",
    title: "User email",
    searchPlaceholder: "Separate email by comma",
    type: "tags",
    withHide: true
  },
  business_account: {
    id: "business_account",
    label: "Business account",
    title: "Business account",
    searchPlaceholder: "Separate account by comma",
    type: "tags"
  },
  business_name: {
    id: "business_name",
    label: "Business account",
    title: "Business account",
    searchPlaceholder: "Separate account by comma",
    type: "tags"
  },
  business_url: {
    id: "business_url",
    label: "Business URL",
    title: "Business URL",
    searchPlaceholder: "Separate URL by comma",
    type: "tags"
  },
  transaction_timestamp: {
    id: "transaction_timestamp",
    label: "Transaction Date",
    type: "date"
  },
  alert_timestamp: {
    id: "alert_timestamp",
    label: "Alert Date",
    type: "date"
  },
  amount: {
    id: "amount",
    label: "Order value",
    title: "Filter by amount",
    type: "number",
    min: 0
  },
  // gift_amount: {
  //   id: 'gift_amount',
  //   label: 'Sum',
  //   title: 'Filter by Sum',
  //   type: 'number',
  //   min: 0,
  // },
  invoice_amount: {
    id: "invoice_amount",
    label: "Invoice amount",
    title: "Filter by amount",
    type: "number",
    min: 0
  },
  merchant_descriptor: {
    id: "merchant_descriptor",
    label: "Billing Descriptor",
    allBtnText: "All Descriptors",
    type: "checkbox",
    withSearch: true,
    withNoOption: true,
    noOptionLabel: "No Descriptor",
    // Sentinel the backend expects for "records without any descriptor" (an empty value is ignored)
    noOptionValue: "No descriptor"
  },
  loyal_billing: {
    id: "loyal_billing",
    label: "Loyal billing",
    allBtnText: "All",
    type: "checkbox"
  },
  payment_system: {
    id: "payment_system",
    label: "Payment system",
    allBtnText: "All",
    type: "checkbox"
  },
  country: {
    id: "country",
    label: "Country",
    allBtnText: "All countries",
    type: "checkbox",
    withSearch: true,
    sortDisabled: true
  },
  invoice_id: {
    id: "invoice_id",
    label: "Invoice ID",
    searchPlaceholder: "Separate ID by comma",
    type: "tags"
  },
  payment_processor: {
    id: "payment_processor",
    label: "Processor",
    allBtnText: "All payment processors",
    type: "checkbox"
  },
  bank_name: {
    id: "bank_name",
    label: "Bank",
    allBtnText: "All banks",
    type: "checkbox",
    withSearch: true
  },
  alert_id: {
    id: "alert_id",
    label: "Alert ID",
    searchPlaceholder: "Separate ID by comma",
    type: "tags"
  },
  transaction_id: {
    id: "transaction_id",
    label: "Transaction ID",
    searchPlaceholder: "Separate ID by comma",
    type: "tags"
  },
  card_last4: {
    id: "card_last4",
    label: "Card",
    title: "Last 4 card digits",
    searchPlaceholder: "Separate digits by comma",
    type: "tags"
  },
  //admin part
  status: {
    id: "status",
    label: "Status",
    allBtnText: "All statuses",
    type: "checkbox"
  },
  request_status: {
    id: "request_status",
    label: "Status",
    allBtnText: "All statuses",
    type: "checkbox"
  },
  alerts_count: {
    id: "alerts_count",
    label: "Alerts sent",
    title: "Filter by alerts",
    type: "number",
    min: 0
  },
  paid_alerts_count: {
    id: "paid_alerts_count",
    label: "Paid Alerts",
    title: "Filter by paid alerts",
    type: "number",
    min: 0
  },
  enrollments: {
    id: "enrollments",
    label: "Enrollments",
    searchPlaceholder: "Separate enrollments by comma",
    type: "tags"
  },
  alert_service: {
    id: "alert_service",
    label: "Alert source",
    allBtnText: "All alerts source",
    type: "checkbox"
  },
  billing_descriptors: {
    id: "billing_descriptors",
    label: "Billing Descriptor",
    allBtnText: "All Descriptors",
    type: "checkbox",
    withNoOption: true,
    noOptionLabel: "No Descriptor"
  },
  connected_payment_processors: {
    id: "connected_payment_processors",
    label: "Processor",
    allBtnText: "All payment processors",
    type: "checkbox"
  },
  created_timestamp: {
    id: "created_timestamp",
    label: "Creation Date",
    type: "date"
  },
  updated_timestamp: {
    id: "updated_timestamp",
    label: "Update status date",
    type: "date"
  },
  enable_auto_refunds: {
    id: "enable_auto_refunds",
    label: "Auto-refund Ethoca&CDRN",
    allBtnText: "All",
    type: "checkbox"
  },
  auto_refund_amount_other: {
    id: "auto_refund_amount_other",
    label: "Auto-refund amount Ethoca&CDRN",
    title: "Filter by amount",
    type: "number",
    min: 0
  },
  auto_refund_amount_rdr: {
    id: "auto_refund_amount_rdr",
    label: "Auto-refund amount RDR",
    title: "Filter by amount",
    type: "number",
    min: 0
  },
  current_amount: {
    id: "current_amount",
    label: "Current amount",
    title: "Filter by amount",
    type: "number",
    min: 0
  },
  requested_amount: {
    id: "requested_amount",
    label: "Requested amount",
    title: "Filter by amount",
    type: "number",
    min: 0
  },
  user_card: {
    id: "user_card",
    label: "Card",
    title: "Last 4 card digits",
    searchPlaceholder: "Separate digits by comma",
    type: "tags"
  },
  arn_codes: {
    //for requestPage
    id: "arn_codes",
    label: "ARN codes",
    searchPlaceholder: "Separate ARN codes by comma",
    type: "tags",
    withNoValue: true,
    noValueLabel: "Show results with no ARN codes"
  },
  bin_codes: {
    //for requestPage
    id: "bin_codes",
    label: "BIN codes",
    searchPlaceholder: "Separate BIN codes by comma",
    type: "tags",
    withNoValue: true,
    noValueLabel: "Show results with no BIN codes"
  },
  caid_codes: {
    //for requestPage
    id: "caid_codes",
    label: "CAID codes",
    searchPlaceholder: "Separate CAID codes by comma",
    type: "tags",
    withNoValue: true,
    noValueLabel: "Show results with no CAID codes"
  },
  request_type: {
    id: "request_type",
    label: "Request type",
    allBtnText: "All",
    type: "checkbox"
  },
  integration_url: {
    id: "integration_url",
    label: "Integration URL",
    searchPlaceholder: "Separate URL by comma",
    type: "tags"
  },
  description: {
    id: "description",
    label: "Description",
    searchPlaceholder: "Separate description by comma",
    type: "tags"
  },
  is_use_another_solutions: {
    id: "is_use_another_solutions",
    label: "Using Competitor",
    allBtnText: "All",
    type: "checkbox"
  },
  another_solution_name: {
    id: "another_solution_name",
    label: "Previous solution",
    searchPlaceholder: "Separate details by comma",
    type: "tags"
  },
  previously_connected_enrollments: {
    id: "previously_connected_enrollments",
    label: "Previously enrolled",
    searchPlaceholder: "Separate enrollments by comma",
    allBtnText: "All options",
    type: "checkbox",
    sortDisabled: true
  },
  shopify_invoice_id: {
    id: "shopify_invoice_id",
    label: "Invoice id",
    searchPlaceholder: "Separate invoice ID by comma",
    type: "tags"
  },
  is_user_notified_previous_solution: {
    id: "is_user_notified_previous_solution",
    label: "Previous partner notified",
    allBtnText: "All",
    type: "checkbox"
  },
  media_source: {
    id: "media_source",
    label: "How did you hear about us",
    allBtnText: "All",
    type: "checkbox"
  },
  alerts_period: {
    id: "alerts_period",
    label: "Alerts period",
    type: "date"
  },
  invoice_date: {
    id: "invoice_date",
    label: "Invoice date",
    type: "date"
  },
  is_reissued: {
    id: "is_reissued",
    label: "Reissued",
    allBtnText: "All",
    type: "checkbox"
  },
  pricing_schema: {
    id: "pricing_schema",
    label: "Pricing scheme",
    allBtnText: "All pricing",
    type: "checkbox"
  },
  type: {
    id: "type",
    label: "Type",
    allBtnText: "All types",
    type: "checkbox"
  },
  applied: {
    id: "applied",
    label: "Applied",
    allBtnText: "All",
    type: "checkbox"
  },
  count_of_free_alerts: {
    id: "count_of_free_alerts",
    label: "Free alerts",
    title: "Filter by number of the first alerts to skip",
    type: "whole_number",
    min: 0
  },
  customer_unsubscribed: {
    id: "customer_unsubscribed",
    label: "Subscription canceled",
    allBtnText: "All",
    type: "checkbox"
  },
  auto_cancel_subscriptions: {
    id: "auto_cancel_subscriptions",
    label: "Auto-cancel subscriptions",
    allBtnText: "All",
    type: "checkbox"
  },
  auto_cancel_amount: {
    id: "auto_cancel_amount",
    label: "Auto-cancel amount",
    title: "Filter by amount",
    type: "number",
    min: 0
  },
  arn: {
    //for alertsPage
    id: "arn",
    label: "ARN",
    searchPlaceholder: "Separate ARN by comma",
    type: "tags"
  },
  auth_code: {
    id: "auth_code",
    label: "Auth.Code",
    searchPlaceholder: "Separate Auth.Code by comma",
    type: "tags"
  },
  last_active: {
    id: "last_active",
    label: "Last active",
    type: "date"
  },
  ba_status: {
    id: "ba_status",
    label: "BA status",
    allBtnText: "All statuses",
    type: "checkbox"
  },
  role: {
    id: "role",
    label: "Role",
    allBtnText: "All roles",
    type: "checkbox",
    filterKey: "value"
  },
  invite_sent: {
    id: "invite_sent",
    label: "Invite sent",
    type: "date"
  },
  last_2fa_access: {
    id: "last_2fa_access",
    label: "Last 2FA access",
    type: "date"
  },
  last_activity: {
    id: "last_activity",
    label: "Last activity",
    type: "date"
  },
  role_status: {
    id: "role_status",
    label: "Role status",
    allBtnText: "All statuses",
    type: "checkbox"
  },
  /*user_visibility: {
    id: 'user_visibility',
    label: 'User visibility',
    allBtnText: 'All',
    type: 'checkbox',
  },*/
  paid_status: {
    id: "paid_status",
    label: "Paid status",
    allBtnText: "All",
    type: "checkbox"
  },
  status_set: {
    id: "status_set",
    label: "Status set",
    allBtnText: "All",
    type: "checkbox",
    noStatusStyles: true
  },
  credit_request_type: {
    id: "credit_request_type",
    label: "Credit request",
    allBtnText: "All",
    type: "checkbox"
  },
  request_date_timestamp: {
    id: "request_date_timestamp",
    label: "Request date",
    type: "date"
  },
  update_date_timestamp: {
    id: "update_date_timestamp",
    label: "Update date",
    type: "date"
  },
  request_amount: {
    id: "request_amount",
    label: "Alert cost",
    title: "Filter by alert cost",
    type: "number",
    min: 0
  },
  attachments: {
    id: "attachments",
    label: "Attachments",
    title: "Filter by attachments",
    type: "number",
    min: 0
  },
  request_reason: {
    id: "request_reason",
    label: "Request reason",
    allBtnText: "All reasons",
    type: "checkbox"
  },
  rejection_reason: {
    id: "rejection_reason",
    label: "Rejection reason",
    allBtnText: "All reasons",
    type: "checkbox"
  },
  provider_reason: {
    id: "provider_reason",
    label: "Provider reason",
    allBtnText: "All reasons",
    type: "checkbox"
  },
  provider_status: {
    id: "provider_status",
    label: "Provider status",
    allBtnText: "All statuses",
    type: "checkbox"
  },
  balance_current: {
    id: "balance_current",
    label: "Current Balance",
    title: "Filter by balance",
    type: "number"
  },
  balance_usage: {
    id: "balance_usage",
    label: "Balance usage",
    allBtnText: "All",
    type: "checkbox"
  },
  updated_stripe_perm: {
    id: "updated_stripe_perm",
    label: "Stripe updated (BH)",
    allBtnText: "All",
    type: "checkbox"
  },
  mode: {
    id: "mode",
    label: "Mode",
    allBtnText: "All",
    type: "checkbox"
  },
  // stripe_charged: {
  //   id: 'stripe_charged',
  //   label: 'Stripe charged',
  //   allBtnText: 'All',
  //   type: 'checkbox',
  // },
  charge_by: {
    id: "charge_by",
    label: "Charge By",
    allBtnText: "All",
    type: "checkbox"
  },
  admin_comment: {
    id: "admin_comment",
    label: "Comment",
    searchPlaceholder: "Separate comment by comma",
    type: "tags"
  },
  admin_screenshots: {
    id: "admin_screenshots",
    label: "Screenshots",
    allBtnText: "All",
    type: "checkbox"
  },
  alerts_in_debt_count: {
    id: "alerts_in_debt_count",
    label: "Alerts in Debt",
    title: "Filter by alerts in debt",
    type: "number"
  },
  locked: {
    id: "locked",
    label: "Locked",
    allBtnText: "All",
    type: "checkbox"
  },
  last_lock_at: {
    id: "last_lock_at",
    label: "Last lock at",
    type: "date"
  },
  categories: {
    id: "categories",
    label: "Type",
    allBtnText: "All",
    type: "checkbox"
  },
  visits_updated: {
    id: "visits_updated",
    label: "Visits Updated",
    type: "date"
  },
  visits_per_month: {
    id: "visits_per_month",
    label: "Visits per month",
    title: "Filter by visits per month",
    type: "number",
    min: 0
  },
  original_alert_id: {
    id: "original_alert_id",
    label: "Original alert",
    searchPlaceholder: "Separate ID by comma",
    type: "tags"
  },
  billing_descriptor_status: {
    id: "billing_descriptor_status",
    label: "Descriptor status",
    allBtnText: "All statuses",
    type: "checkbox"
  }
}

export const filtersTypeByIdMap = {
  requests: {
    ...filtersTypeById,
    created_timestamp: {
      id: "created_timestamp",
      label: "Request date",
      type: "date"
    },
    enrollments: {
      id: "enrollments",
      label: "Enrollments",
      allBtnText: "All Enrollments",
      type: "checkbox",
      sortDisabled: true
    },
    visa_arn_code_date: {
      id: "visa_arn_code_date",
      label: "ARN Added Date",
      type: "date"
    }
  },
  receipts: {
    ...filtersTypeById,
    created_timestamp: {
      id: "created_timestamp",
      label: "Request date",
      type: "date"
    },
    enrollments: {
      id: "enrollments",
      label: "Enrollments",
      allBtnText: "All Enrollments",
      type: "checkbox",
      sortDisabled: true,
      allOptionLast: true
    },
    programs: {
      id: "programs",
      label: "Programs",
      allBtnText: "All Programs",
      type: "checkbox"
    },
    visa_arn_code_date: {
      id: "visa_arn_code_date",
      label: "ARN Added Date",
      type: "date"
    }
  },
  gifts: {
    ...filtersTypeById,
    created_timestamp: {
      id: "created_timestamp",
      label: "Created date",
      type: "date"
    },
    amount: {
      id: "amount",
      label: "Sum",
      title: "Filter by sum",
      type: "number",
      min: 0
    }
  },
  withdrawal: {
    ...filtersTypeById,
    created_timestamp: {
      id: "created_timestamp",
      label: "Created date",
      type: "date"
    },
    amount: {
      id: "amount",
      label: "Sum",
      title: "Filter by sum",
      type: "number",
      min: 0
    },
    attachments: {
      id: "attachments",
      label: "Attachments",
      title: "Filter by attachments",
      type: "whole_number",
      min: 0
    }
  },
  credits: {
    ...filtersTypeById,
    attachments: {
      id: "attachments",
      label: "Attachments",
      title: "Filter by attachments",
      type: "whole_number",
      min: 0
    },
    alert_status: {
      id: "alert_status",
      label: "Alert status",
      allBtnText: "All statuses",
      type: "checkbox"
    },
    request_status: {
      id: "request_status",
      label: "Request status",
      allBtnText: "All statuses",
      type: "checkbox"
    }
  },
  payment_activity: {
    ...filtersTypeById,
    subtype: {
      id: "subtype",
      label: "Type",
      allBtnText: "All types",
      type: "checkbox"
    },
    id: {
      id: "id",
      label: "Transaction ID",
      searchPlaceholder: "Separate ID by comma",
      type: "tags"
    },
    source_id: {
      id: "source_id",
      label: "Source ID",
      searchPlaceholder: "Separate ID by comma",
      type: "tags"
    },
    source_type: {
      id: "source_type",
      label: "Payment Source",
      allBtnText: "All payment source",
      type: "checkbox"
    },
    amount: {
      id: "amount",
      label: "Amount",
      title: "Filter by amount",
      type: "number",
      min: 0
    },
    balance_transaction_timestamp: {
      id: "balance_transaction_timestamp",
      label: "Date",
      type: "date"
    },
    card_last4: {
      id: "card_last4",
      label: "Payment Method",
      title: "Last 4 card digits",
      searchPlaceholder: "Separate digits by comma",
      type: "tags"
    },
    business_account: {
      id: "business_account",
      label: "Business account",
      title: "Account",
      searchPlaceholder: "Separate account by comma",
      type: "tags"
    },
    balance_before: {
      id: "balance_before",
      label: "Balance Before",
      title: "Filter by amount",
      type: "number"
    },
    balance_after: {
      id: "balance_after",
      label: "Balance After",
      title: "Filter by amount",
      type: "number"
    }
  },
  invoice_history: {
    ...filtersTypeById,
    invoice_amount: {
      id: "invoice_amount",
      label: "Amount",
      title: "Filter by amount",
      type: "number",
      min: 0
    },
    date: {
      id: "date",
      label: "Date",
      type: "date"
    },
    invoice_id: {
      id: "invoice_id",
      label: "Transaction ID",
      searchPlaceholder: "Separate ID by comma",
      type: "tags"
    },
    paid_with: {
      id: "paid_with",
      label: "Paid with",
      allBtnText: "All",
      type: "checkbox"
    },
    topup_type: {
      id: "topup_type",
      label: "Type",
      allBtnText: "All types",
      type: "checkbox"
    },
    card_last4: {
      id: "card_last4",
      label: "Payment Method",
      title: "Last 4 card digits",
      searchPlaceholder: "Separate digits by comma",
      type: "tags"
    },
    balance_before: {
      id: "balance_before",
      label: "Balance Before",
      title: "Filter by amount",
      type: "number"
    },
    balance_after: {
      id: "balance_after",
      label: "Balance After",
      title: "Filter by amount",
      type: "number"
    }
  },
  referrals: {
    affiliate_full_name: {
      id: "affiliate_full_name",
      label: "Affiliate",
      title: "Affiliate full name",
      searchPlaceholder: "Separate full name by comma",
      type: "tags"
    },
    affiliate_email: {
      id: "affiliate_email",
      label: "Affiliate email",
      title: "Affiliate email",
      searchPlaceholder: "Separate email by comma",
      type: "tags"
    },
    referral_full_name: {
      id: "referral_full_name",
      label: "Invited referral",
      title: "Referral full name",
      searchPlaceholder: "Separate full name by comma",
      type: "tags"
    },
    referral_email: {
      id: "referral_email",
      label: "Invited referral email",
      title: "Referral email",
      searchPlaceholder: "Separate email by comma",
      type: "tags"
    },
    referral_status: {
      id: "referral_status",
      label: "Referral status",
      allBtnText: "All statuses",
      type: "checkbox"
    },
    business_account_created: {
      id: "business_account_created",
      label: "Date",
      type: "date"
    },
    business_account_name: {
      id: "business_account_name",
      label: "Referral BA",
      title: "Referral BA",
      searchPlaceholder: "Separate account by comma",
      type: "tags"
    },
    business_account_status: {
      id: "business_account_status",
      label: "BA status",
      allBtnText: "All statuses",
      type: "checkbox"
    }
  },
  verifi_inform: {
    ...filtersTypeById,
    status: {
      id: "status",
      label: "Status",
      allBtnText: "All statuses",
      type: "checkbox",
      noStatusStyles: true
    },
    created: {
      id: "created",
      label: "Request date",
      type: "date"
    },
    updated: {
      id: "updated",
      label: "Update status date",
      type: "date"
    },
    ba_name: {
      id: "ba_name",
      label: "Business account",
      title: "Business account",
      searchPlaceholder: "Separate account by comma",
      type: "tags"
    },
    user_name: {
      id: "user_name",
      label: "User name",
      title: "User name",
      searchPlaceholder: "Separate user name by comma",
      type: "tags"
    },
    events_table: {
      event_name: {
        id: "event_name",
        label: "Event name",
        allBtnText: "All",
        type: "checkbox"
      },
      source_id: {
        id: "source_id",
        label: "Source ID",
        searchPlaceholder: "Separate ID by comma",
        type: "tags"
      },
      created_timestamp: {
        id: "created_timestamp",
        label: "Date",
        type: "date"
      }
    }
  },
  admin_users: {
    ...filtersTypeById,
    email: {
      id: "email",
      label: "Admin email",
      title: "Admin email",
      searchPlaceholder: "Separate email by comma",
      type: "tags",
      withHide: true
    },
    admin_full_name: {
      id: "admin_full_name",
      label: "Admin full name",
      title: "Admin full name",
      searchPlaceholder: "Separate full name by comma",
      type: "tags"
    }
  },
  perksAdmin: {
    partner_name: {
      id: "partner_name",
      label: "Partner name",
      allBtnText: "All partners",
      type: "checkbox",
      withSearch: true
    },
    created: {
      id: "created",
      label: "Created",
      type: "date"
    }
  },
  // CHA1-1769 — User-side Receipt "Lookup activity" filter bar (§BLOCK 4.2).
  receipt: {
    date: {
      id: "date",
      label: "Date",
      type: "date"
    },
    card: {
      id: "card",
      label: "Card",
      title: "Last 4 card digits",
      searchPlaceholder: "Separate digits by comma",
      type: "tags"
    },
    amount: {
      id: "amount",
      label: "Amount",
      title: "Filter by amount",
      type: "number",
      min: 0
    },
    program: {
      id: "program",
      label: "Program",
      allBtnText: "All Programs",
      type: "checkbox"
    },
    channel: {
      id: "channel",
      label: "Channel",
      allBtnText: "All Channels",
      type: "checkbox"
    },
    fee_charged: {
      id: "fee_charged",
      label: "Fee charged",
      title: "Filter by fee",
      type: "number",
      min: 0
    }
  },
  business_accounts: {
    ...filtersTypeById,
    enrollments: {
      id: "enrollments",
      label: "Enrollments",
      allBtnText: "All Enrollments",
      type: "enrollments"
    },
    receipt_status: {
      id: "receipt_status",
      label: "Receipt status",
      allBtnText: "All receipt statuses",
      type: "checkbox",
      // The API sends { value, name } pairs; without this the dropdown would submit
      // the label, and "Needs Help" / "Not Enrolled" do not match their enum values.
      filterKey: "value",
      // The shared status-tag renderer keys off an id containing "status" and assumes
      // string options, so it would call el.toLowerCase() on these objects.
      noStatusStyles: true
    },
    programs: {
      id: "programs",
      label: "Programs",
      allBtnText: "All programs",
      type: "checkbox",
      filterKey: "value"
    }
  }
}
